import React from 'react';
import './assets/css/app.css';
import { HashRouter, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Profil from './components/Profil';
import Connect from './components/Connect';
import Colis from './components/Colis';
import ColisMessages from './components/ColisMessages';
import Factures from './components/Factures';
import Messages from './components/Messages';
import Resume from './components/Resume';
import ColisMessagerie from './components/ColisMessagerie';
import Notification from './components/Notification';
import ColisLivrer from './components/ColisPartials/ColisLivrer';
import ReplyMessageLivreur from './components/ReplyMessageLivreur';
import ErrorSystem from './components/ColisPartials/ErrorSystem';


export default class App extends React.Component {

    constructor() {
        super();
        this.state = {
            sidebar: false,
            livreur: {},
            current_time: Date.now(),
            current_page: ''
        }
    }

    render() {
        return (
            <HashRouter>
                <div id='app' className='app-container' onClick={(event) => this.closeSidebar(event)}>
                    <div className='app-pusher'>
                        <Sidebar
                            livreur={this.state.livreur}
                            current_time={this.state.current_time}
                            current_url={window.location.href}
                        />
                        <Route exact path='/connect/:token' render={(props) =>
                            <Connect user_token={props.match.params.token} />}
                        />
                        <div className='wrapper'>
                            <div className="content d-flex flex-column w-100">
                                <Header
                                    openSidebar={this.openSidebar}
                                    openErrorSystem={this.openErrorSystem}
                                    loaderDisplay={this.loaderDisplay}
                                    livreur={this.state.livreur}
                                    setLivreur={this.setLivreur}
                                    setNotifications={this.setNotifications}
                                    showModal={this.showModal}
                                    setCurrentPage={this.setCurrentPage}
                                    current_page={this.state.current_page}
                                />
                                <main id="main" className="flex-shrink-0">
                                    <div className="container-fluid" id="main-container">
                                        <Route exact path='/' render={() =>
                                            <Home
                                                loaderDisplay={this.loaderDisplay}
                                                openErrorSystem={this.openErrorSystem}
                                                livreur={this.state.livreur}
                                            />}
                                        />
                                        <Route exact path='/reply/message-livreur' render={(props) =>
                                            <ReplyMessageLivreur
                                                statut={props.match.params.statut}
                                                openErrorSystem={this.openErrorSystem}
                                                setLivreur={this.setLivreur}
                                                loaderDisplay={this.loaderDisplay}
                                                showModal={this.showModal}
                                                setCurrentPage={this.setCurrentPage}
                                                current_page={this.state.current_page}
                                                current_time={this.state.current_time}
                                            />}
                                        />

                                        <Route exact path='/colis-messagerie' render={() =>
                                            <ColisMessagerie
                                                openErrorSystem={this.openErrorSystem}
                                                setLivreur={this.setLivreur}
                                                loaderDisplay={this.loaderDisplay}
                                                showModal={this.showModal}
                                                setCurrentPage={this.setCurrentPage}
                                                current_page={this.state.current_page}
                                                current_time={this.state.current_time}
                                            />}
                                        /> 

                                        <Route exact path='/colis/:statut' render={(props) =>
                                            <Colis
                                                statut={props.match.params.statut}
                                                openErrorSystem={this.openErrorSystem}
                                                setLivreur={this.setLivreur}
                                                loaderDisplay={this.loaderDisplay}
                                                showModal={this.showModal}
                                                setCurrentPage={this.setCurrentPage}
                                                current_page={this.state.current_page}
                                            />}
                                        />
                                        <Route exact path='/colis-message' render={(props) =>
                                            <ColisMessages
                                                statut={props.match.params.statut}
                                                openErrorSystem={this.openErrorSystem}
                                                setLivreur={this.setLivreur}
                                                loaderDisplay={this.loaderDisplay}
                                                showModal={this.showModal}
                                                setCurrentPage={this.setCurrentPage}
                                                current_page={this.state.current_page}
                                            />}
                                        />
                                        <Route exact path='/notifications' render={() =>
                                            <Notification
                                                loaderDisplay={this.loaderDisplay}
                                                openErrorSystem={this.openErrorSystem}
                                                notifications={this.state.notifications}
                                            />}
                                        />
                                        <Route exact path='/factures' render={() =>
                                            <Factures
                                                loaderDisplay={this.loaderDisplay}
                                                openErrorSystem={this.openErrorSystem}
                                                livreur={this.state.livreur}
                                                setLivreur={this.setLivreur}
                                                loaderDisplay={this.loaderDisplay}
                                                showModal={this.showModal}
                                                setCurrentPage={this.setCurrentPage}
                                                current_page={this.state.current_page}
                                            />}
                                        /> 

                                        <Route exact path='/messages' render={() =>
                                            <Messages
                                                loaderDisplay={this.loaderDisplay}
                                                openErrorSystem={this.openErrorSystem}
                                                livreur={this.state.livreur}
                                                setLivreur={this.setLivreur}
                                                loaderDisplay={this.loaderDisplay}
                                                showModal={this.showModal}
                                                setCurrentPage={this.setCurrentPage}
                                                current_page={this.state.current_page}
                                            />}
                                        />
                                        <Route exact path='/resume' render={() =>
                                            <Resume
                                                loaderDisplay={this.loaderDisplay}
                                                openErrorSystem={this.openErrorSystem}
                                                livreur={this.state.livreur}
                                            />}
                                        />

                                        <Route exact path='/home' render={() =>
                                            <Home
                                                loaderDisplay={this.loaderDisplay}
                                                openErrorSystem={this.openErrorSystem}
                                                livreur={this.state.livreur}
                                            />}
                                        />

                                        <Route exact path='/password' render={() =>
                                            <Profil
                                                loaderDisplay={this.loaderDisplay}
                                                openErrorSystem={this.openErrorSystem}
                                            />}
                                        />
                                        <Route exact path='/user-logout' render={() => this.userLogout()} />
                                    </div>
                                </main>
                                <Footer />
                            </div>
                        </div>
                    </div>

                    <div id="loader" className="loader">
                        <div>
                            <div className="loader-animation">
                                <div></div><div></div><div></div><div></div>
                                <div></div><div></div><div></div><div></div>
                                <div></div>
                            </div><br />
                            <h3 className="mb-4 text-uppercase">Faster Ship Log</h3>
                            <p className="text-mute">Fastershiplog La solution <br />d’envoi de vos colis à domicile</p>
                        </div>
                    </div>

                    {this.state.show_modal && (
                        <div className="row">
                            <div className="col-12 col-md-12">
                                <div className="modal show d-block" style={{ 'background': 'rgba(0, 0, 0, 0.5)' }}>
                                    <div className="modal-dialog" style={{ 'marginTop': '50%' }}>
                                        {this.state.show_modal === 'colis_livrer' && (
                                            <div className="modal-content gradient-blue text-white">
                                                <ColisLivrer
                                                    showModal={this.showModal}
                                                    selected_coli={this.state.selected_coli}
                                                    loaderDisplay={this.loaderDisplay}
                                                    openErrorSystem={this.openErrorSystem}
                                                    setLivreur={this.setLivreur}
                                                    setCurrentPage={this.setCurrentPage}
                                                />
                                            </div>
                                        )}
                                        {this.state.show_modal === 'notification' && (
                                            <Notification
                                                notifications={this.state.notifications}
                                                showModal={this.showModal}
                                                openErrorSystem={this.openErrorSystem}
                                            />
                                        )}

                                        {this.state.show_modal === 'ErrorSystem' && (
                                            <div className="modal-content gradient-danger text-white">
                                                <ErrorSystem
                                                    showModal={this.showModal}
                                                    loaderDisplay={this.loaderDisplay}
                                                    setLivreur={this.setLivreur}
                                                    setCurrentPage={this.setCurrentPage}
                                                    openErrorSystem={this.openErrorSystem}
                                                />
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </HashRouter>
        );
    }

    setCurrentPage = (v) => {
        this.setState({ current_page: v })
    }

    setLivreur = (infos) => {
        this.setState({ livreur: infos }, function () {
            this.forceUpdate();
        });
    }

    setNotifications = (notifications) => {
        this.setState({ notifications: notifications })
    }

    showModal = (v, coli = {}) => {
        this.setState({
            show_modal: v,
            selected_coli: coli
        }, function () {
            var div = document.getElementById('om-body');
            if (div.classList.contains('modal-open')) {
                div.classList.remove('modal-open');
            } else {
                div.classList.add('modal-open');
            }
        });
    }

    loaderDisplay = (show = false, timee = 0) => {
        if (show === true) {
            document.getElementById('loader').style.display = 'flex';
        } else {
            setTimeout(function () {
                document.getElementById('loader').style.display = 'none';
            }, timee);
        }
    }

    openSidebar = () => {
        var container = document.getElementById('app');
        container.classList.add('app-menu-open');
        this.setState({
            sidebar: true,
            current_time: Date.now()
        });
    }

    closeSidebar = (event) => {
        if (this.state.sidebar) {
            if (event.target.classList.contains('dropdown-nav') || event.target.closest('.dropdown-nav')) return;
            var container = document.getElementById('app');
            if (container.classList.contains('app-menu-open')) {
                container.classList.remove('app-menu-open');
                this.setState({ sidebar: false });
            }
        }
    }

    userLogout = () => {
        if (window.isNativeApp) {
            this.loaderDisplay(true);
            return window.ReactNativeWebView.postMessage("user-logout");
        }
    }

    openErrorSystem = (v) => {
        this.showModal(false)
        this.showModal('ErrorSystem')
    } 

}
